// src/components/ReferralInviteQR.jsx
import { useRef } from "react";
import { Box, Button, Text, useToast } from "@chakra-ui/react";
import { QRCodeCanvas } from "qrcode.react"; // ✅ use directly

/**
 * ReferralInviteQR renders a QR code for the referral link.
 * - Uses referrerId (UUID or integer depending on migration).
 * - Allows download of the QR code as PNG.
 */
export default function ReferralInviteQR({ referrerId }) {
  const qrRef = useRef(null);
  const toast = useToast();

  const inviteLink = `https://postcode.coupons/signup?ref=${referrerId}`;

  const downloadQR = () => {
    try {
      const canvas = qrRef.current?.querySelector("canvas"); // ✅ get the actual <canvas>
      if (!canvas) throw new Error("QR canvas not found");

      const pngUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = pngUrl;
      link.download = `referral-qr-${referrerId}.png`;
      link.click();

      toast({
        title: "QR code downloaded",
        description: "Referral QR saved as PNG.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (err) {
      console.error("[ReferralInviteQR] QR download error:", err);
      toast({
        title: "Download failed",
        description: "Unable to save QR code.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box textAlign="center" mt={4} ref={qrRef}>
      <QRCodeCanvas value={inviteLink} size={180} />
      <Text mt={2} fontSize="sm" color="gray.600" wordBreak="break-all">
        {inviteLink}
      </Text>
      <Button mt={2} onClick={downloadQR} colorScheme="blue">
        Download QR
      </Button>
    </Box>
  );
}
